import React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { updateClientsByAppInstance } from '../apis';

const useUpdateClientByAppInstance = () => {
  const queryClient = useQueryClient();

  const mutationAction = useMutation({
    mutationFn: updateClientsByAppInstance,
    onSuccess: (data) => {
      toast.success('Update Idp Client successfully');
      queryClient.refetchQueries(
        'app-clients-list-by-app-instance-' + data?.AppInstanceId,
      );
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Server error';
      toast.error(message);
      console.error('Error Update Idp Client:', error);
    },
  });

  return mutationAction;
};

export default useUpdateClientByAppInstance;
